import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { setWindowMode } from '../../../../../utils/responseWindow';

/**
 * 定义 ChannelNav 组件
 */
class ChannelNav extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        windowMode: PropTypes.string,
    };

    render() {
        const {
            content: { topNav, subNav },
            windowMode,
        } = this.props;

        const topNavList = topNav.map((item, index) => (
            <li key={`topNav_${index}`}>
                <a href={item.url} className={index === 0 ? styles.topNav_leftLine : null} target="_blank" rel={rel}>
                    {item.title}
                </a>
            </li>
        ));

        const subNavList = subNav.map((item, index) => (
            <li key={`topNav_${index}`} className={index % 3 === 0 && index !== 0 ? styles.subNav_leftLine : null}>
                <a href={item.url} target="_blank" rel={rel}>
                    {item.title}
                </a>
            </li>
        ));

        return (
            <div className={`${styles.navBox} ${windowMode === 'wide' ? styles.wide : null}`}>
                <div className={styles.topNavBox}>
                    <ul className={styles.topNav}>{topNavList}</ul>
                </div>
                <div className={styles.subNavBox}>
                    <ul className={styles.subNav}>{subNavList}</ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ChannelNav);
